export enum HttpStatus {
	ERROR = "ERROR",
	SUCCESS = "SUCCESS",
	UNAUTHORIZED = "UNAUTHORIZED",
	INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
	NO_ACCESS = "NO_ACCESS",
	UNDEFINED = "UNDEFINED",
	CONFLICT = "CONFLICT",
	USERNAME_ALREADY_EXISTS = "USERNAME_ALREADY_EXISTS",
	EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
	USER_NOT_ACTIVE = "USER_NOT_ACTIVE",
	BAD_REQUEST = "BAD_REQUEST",
	UNKNOWN_ERROR = "UNKNOWN_ERROR",
	METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
	INCORRECT_PASSWORD = "INCORRECT_PASSWORD",
	INCORRECT_USERNAME = "INCORRECT_USERNAME",
	SUPPLIER_BAD_REQUEST = "SUPPLIER_BAD_REQUEST",
	SUPPLIER_NOT_FOUND = "SUPPLIER_NOT_FOUND",
	VENDOR_NOT_FOUND = "VENDOR_NOT_FOUND",
	VENDOR_SUPPLIER_NOT_FOUND = "VENDOR_SUPPLIER_NOT_FOUND",
	USER_NOT_FOUND = "USER_NOT_FOUND",
	EXCEL_FORMAT_BAD_REQUEST = "EXCEL_FORMAT_BAD_REQUEST",
	EXCEL_ERRORS_BAD_REQUEST = "EXCEL_ERRORS_BAD_REQUEST",
	ALREADY_LINKED = "ALREADY_LINKED",
	LINK_NOT_FOUND = "LINK_NOT_FOUND",
	EMPTY_FILE = "EMPTY_FILE",
	SOME_SKUS_NOT_FOUND = "SOME_SKUS_NOT_FOUND",
	TOO_MANY_SKUS = "TOO_MANY_SKUS",
	FILE_NOT_FOUND = "FILE_NOT_FOUND",
	ENCRYPTION_BAD_REQUEST = "ENCRYPTION_BAD_REQUEST",
	PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
	API_UNAVAILABLE = "API_UNAVAILABLE",
	API_DESERIALISATION_EXCEPTION = "API_DESERIALISATION_EXCEPTION",
	ITEM_UPDATED_SUCCESSFULLY = "ITEM_UPDATED_SUCCESSFULLY",
	UPDATE_ALL_NOT_VALID = "UPDATE_ALL_NOT_VALID",
	INVALID_VENDOR_NUMBER = "INVALID_VENDOR_NUMBER",
	SUPPLIER_HAS_NO_ITEMS = "SUPPLIER_HAS_NO_ITEMS",
	NO_CHANGES = "NO_CHANGES",
	NO_LETTERS_ALLOWED = "NO_LETTERS_ALLOWED",
	ONLY_LETTERS_ALLOWED = "ONLY_LETTERS_ALLOWED",
	ONLY_NUMBERS_ALLOWED = "ONLY_NUMBERS_ALLOWED",
	NO_ITEMS_TO_UPDATE_BAD_REQUEST = "NO_ITEMS_TO_UPDATE_BAD_REQUEST",
	ITEM_VALIDATION_BAD_REQUEST = "ITEM_VALIDATION_BAD_REQUEST",
	INVALID_INVITATION_BAD_REQUEST = "INVALID_INVITATION_BAD_REQUEST",
	INVITATIONS_RETURNED_ERRORS = "INVITATIONS_RETURNED_ERRORS",
	ROLE_ALREADY_EXISTS = "ROLE_ALREADY_EXISTS",
	NO_ITEMS_TO_UPDATE = "NO_ITEMS_TO_UPDATE",
	ROLE_NOT_FOUND = "ROLE_NOT_FOUND",
	CHARACTER_NOT_ALLOWED_BAD_REQUEST = "CHARACTER_NOT_ALLOWED_BAD_REQUEST",
	ENTITY_TOO_LARGE = "ENTITY_TOO_LARGE",
	INTEGRITY_REGISTRATION_BAD_REQUEST = "INTEGRITY_REGISTRATION_BAD_REQUEST",
	USER_ACTIVATION_FAILED = "USER_ACTIVATION_FAILED",
	EXCEL_TOO_BIG_EMAIL_SENT = "EXCEL_TOO_BIG_EMAIL_SENT",
	EMAIL_NOT_FOUND = "EMAIL_NOT_FOUND",
	FILTERS_NOT_FOUND = "FILTERS_NOT_FOUND",
	INTEGRITY_REGISTRATION_NOT_FOUND = "INTEGRITY_REGISTRATION_NOT_FOUND",
	TOKEN_NOT_FOUND = "TOKEN_NOT_FOUND",
	TOKEN_EXPIRED = "TOKEN_EXPIRED",
	ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
}

export const httpStatusMessages: { [status in HttpStatus]: { title: string; message: string } } = {
	ERROR: { title: "Error", message: "Something went wrong! Please try again later." },
	SUCCESS: { title: "Success", message: "" },
	UNAUTHORIZED: { title: "Session expired", message: "Your session has expired, please sign in." },
	BAD_REQUEST: { title: "Error", message: "Could not complete the action." },
	UNKNOWN_ERROR: { title: "Error", message: "Something went wrong! Please try again later." },
	METHOD_NOT_ALLOWED: { title: "Error", message: "Something went wrong! Please try again later." },
	INVALID_CREDENTIALS: { title: "Invalid credentials", message: "The credentials are invalid." },
	NO_ACCESS: { title: "No access", message: "You do not have permission to access the resource." },
	UNDEFINED: { title: "Error", message: "Something went wrong! Please try again later." },
	CONFLICT: { title: "Conflict", message: "Record already exists." },
	USERNAME_ALREADY_EXISTS: { title: "Conflict", message: "Username already exists." },
	INCORRECT_PASSWORD: { title: "Invalid credentials", message: "Oops! Looks like your credentials are invalid." },
	SUPPLIER_BAD_REQUEST: { title: "Error", message: "Could not finish the request." },
	INCORRECT_USERNAME: { title: "Invalid credentials", message: "Oops! Looks like your credentials are invalid." },
	SUPPLIER_NOT_FOUND: { title: "Supplier not found", message: "The supplier could not be found." },
	VENDOR_NOT_FOUND: { title: "Vendor not found", message: "The vendor could not be found." },
	VENDOR_SUPPLIER_NOT_FOUND: { title: "Vendor not linked", message: "No supplier vendor link found." },
	USER_NOT_FOUND: { title: "User not found", message: "The user could not be found." },
	EXCEL_FORMAT_BAD_REQUEST: { title: "Excel bad format", message: "The provided excel file has a bad format." },
	EXCEL_ERRORS_BAD_REQUEST: { title: "Excel has errors", message: "The provided excel file has errors." },
	ALREADY_LINKED: {
		title: "Already linked",
		message: "Error! This Vendor is already linked to another Supplier. Please contact prop65help@orgill.com for assistance.",
	},
	LINK_NOT_FOUND: { title: "Link not found", message: "No link was found between the vendor and supplier." },
	EMPTY_FILE: { title: "Empty file", message: "No SKUs were found in the uploaded excel." },
	SOME_SKUS_NOT_FOUND: { title: "Not found", message: "Some SKUs were invalid, check them before trying again." },
	TOO_MANY_SKUS: { title: "Too many SKUs", message: "You have exceeded the maximum number of SKUs allowed per upload (3000)." },
	FILE_NOT_FOUND: {
		title: "Not found",
		message: "No file was found. If this error persists, please contact Orgill Customer Service.",
	},
	ENCRYPTION_BAD_REQUEST: { title: "Error", message: "Encrypted data cannot be decrypted." },
	PASSWORD_EXPIRED: { title: "Password expired", message: "The password has expired." },
	API_UNAVAILABLE: { title: "Services are down", message: "The services are currently down, please try again later." },
	API_DESERIALISATION_EXCEPTION: {
		title: "Functionality is down",
		message: "This functionality is currently not working, please try again later.",
	},
	USER_NOT_ACTIVE: { title: "User not active", message: "The user is currently deactivated." },
	ITEM_UPDATED_SUCCESSFULLY: { title: "Success", message: "The item was updated successfully!" },
	UPDATE_ALL_NOT_VALID: {
		title: "Error",
		message: "Changes are not valid, check the errors and try again!",
	},
	INVALID_VENDOR_NUMBER: { title: "Error", message: "The vendor number is not valid!" },
	SUPPLIER_HAS_NO_ITEMS: { title: "Info", message: "This supplier has no items." },
	NO_CHANGES: { title: "No Changes", message: "There were no changes made..." },
	NO_LETTERS_ALLOWED: {
		title: "Only numbers allowed",
		message: "If you want to search by vendor name please switch to the 'Name' option.",
	},
	ONLY_NUMBERS_ALLOWED: {
		title: "Only numbers allowed",
		message: "If you want to search by vendor name please switch to the 'Name' option.",
	},
	ONLY_LETTERS_ALLOWED: {
		title: "Only letters allowed",
		message: "If you want to search by vendor number please switch to the 'Number' option.",
	},
	NO_ITEMS_TO_UPDATE_BAD_REQUEST: {
		title: "Warning",
		message: "There were no changes on the item.",
	},
	ITEM_VALIDATION_BAD_REQUEST: {
		title: "Warning",
		message: "The changes on the item made it invalid, so the update failed.",
	},
	INVALID_INVITATION_BAD_REQUEST: {
		title: "Invitation expired",
		message: "Please contact Orgill Customer Service if you need further assistance.",
	},
	INVITATIONS_RETURNED_ERRORS: {
		title: "There are some errors",
		message: "Some invitations returned errors. Please check them and resend.",
	},
	ROLE_ALREADY_EXISTS: {
		title: "Error",
		message: "A user for this supplier already exists.",
	},
	NO_ITEMS_TO_UPDATE: {
		title: "Warning",
		message: "There were no changes on the item.",
	},
	EMAIL_ALREADY_EXISTS: {
		title: "Error",
		message: "This email already has an account associated to this supplier.",
	},
	ROLE_NOT_FOUND: {
		title: "Error",
		message: "It seems that the supplier's registration is not yet finished or it was altered by an admin.",
	},
	CHARACTER_NOT_ALLOWED_BAD_REQUEST: {
		title: "Error",
		message: "You have used a character that is not allowed. Please try again without using it.",
	},
	ENTITY_TOO_LARGE: {
		title: "Error",
		message: "File size is too large please try again with a smaller document.",
	},
	INTEGRITY_REGISTRATION_BAD_REQUEST: {
		title: "Error",
		message: "The link is no longer available...",
	},
	USER_ACTIVATION_FAILED: {
		title: "User activation failed",
		message: "There is no master account active for this supplier.",
	},
	EXCEL_TOO_BIG_EMAIL_SENT: {
		title: "Email sent",
		message: "The file was too big to be processed, an email was sent to you with the results.",
	},
	EMAIL_NOT_FOUND: {
		title: "Provide an email",
		message: "The file was too big to be processed, please provide an email where the results will be send.",
	},
	FILTERS_NOT_FOUND: {
		title: "Filters not found",
		message: "There are too many items matching your filters. Please add more filters.",
	},
	INTEGRITY_REGISTRATION_NOT_FOUND: { title: "Error", message: "Invalid registration link." },
	TOKEN_NOT_FOUND: { title: "Error", message: "Token not found." },
	TOKEN_EXPIRED: { title: "Session expired", message: "Your session has expired, please sign in again." },
	ACCOUNT_NOT_ACTIVE: {
		title: "Account not active",
		message: "Your account is currently deactivated. Please address this issue with an admin in order to have your account activated again.",
	},
};
